var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcArrowRight16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.24 12.769a.77.77 0 0 1 0-1.117L9.025 8 5.24 4.348a.77.77 0 0 1 0-1.117.84.84 0 0 1 1.157 0l4.363 4.21a.77.77 0 0 1 0 1.117l-4.363 4.21a.84.84 0 0 1-1.157 0",
  clipRule: "evenodd"
})));
export default SvgIcArrowRight16;